module.exports = __webpack_public_path__ + "img/emmanuel_ogbah.df188099.png";